<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Donanım</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name"> 
                <input type="text" v-model="value.Name" class="form-control" placeholder="Donanım"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Kod</label>
            <v-validator :errors="errors" parameter="Code" :watch="value.Code"> 
                <input type="text" v-model="value.Code" class="form-control" placeholder="Kod"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>